import { ROUTER } from '@core/constants/router.constants';
import { HelpDeskPage } from '@modules/helpdesk';
import { HelpDeskLayout } from '@modules/helpdesk/helpdesk.layout';
import { PrivateRoute } from '@router/private-route';
import { RouteObject } from 'react-router-dom';

export const helpDeskRouter: RouteObject = {
  path: ROUTER.HELP_DESK.INDEX,
  Component: HelpDeskLayout,
  children: [{ index: true, element: <PrivateRoute element={<HelpDeskPage />} /> }],
};
